import { equal, isIn, nested } from '@/api/helpers';
import { FiltersType } from '@/api/types';
import { ScopeMode } from '@/client/custom-roles';
import { Group } from '@/client/groups';
import { useAccountUsers } from '@/hooks/query';

type UseAccessScopeCountParams = {
  accountId?: string;
  mode?: ScopeMode | null;
  scopeGroups?: Group[];
  userId?: string;
};

const buildFilters = (
  mode: ScopeMode | null | undefined,
  groupIds: string[],
  userId?: string,
): FiltersType => {
  if (mode === ScopeMode.GROUPS) {
    return [isIn('groups', groupIds)];
  }

  if (mode === ScopeMode.MANAGER) {
    return [nested('companyData', [equal('managerUser', userId as string)])];
  }

  return [];
};

export const useAccessScopeCount = ({
  accountId,
  mode,
  scopeGroups,
  userId,
}: UseAccessScopeCountParams): number | undefined => {
  const groupIds = (scopeGroups ?? []).map(({ id }) => id);

  const enabled =
    !!accountId &&
    (mode === ScopeMode.ALL ||
      (mode === ScopeMode.GROUPS && groupIds.length > 0) ||
      (mode === ScopeMode.MANAGER && !!userId));

  const { users } = useAccountUsers({
    accountId,
    take: 1,
    filters: buildFilters(mode, groupIds, userId),
    enabled,
  });

  return enabled ? users?.count : undefined;
};
